import styled from "styled-components";
export const ProductionLineWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
